import { SEARCH_RESET, SEARCH_UPDATE, SEARCH_SET, SEARCH_TOGGLE } from '@instructure/quiz-common';
export var reset = function reset() {
  return {
    type: SEARCH_RESET
  };
};
export var update = function update(text) {
  return {
    payload: {
      text: text
    },
    type: SEARCH_UPDATE
  };
};
export var toggle = function toggle(filter, key) {
  return {
    payload: {
      filter: filter,
      key: key
    },
    type: SEARCH_TOGGLE
  };
};
export var setFilter = function setFilter(filter, value) {
  return {
    payload: {
      filter: filter,
      value: value
    },
    type: SEARCH_SET
  };
};